module.exports = __webpack_public_path__ + "img/profile.661bc578.svg";